import { useState, useEffect } from "react";
import { FetchedReportData } from "../../types";
import { getTokenizedHeaders } from "../../utils/authHelpers";
import useFetchWithAuth from "./useFetchWithAuth";
import { getApiUrl } from "../../utils/api";

const useFetchReports = () => {
  const { fetchWithAuth } = useFetchWithAuth();
  const [data, setData] = useState<DataType>();
  const [fetchingReports, setFetchingReports] = useState(false);
  const [fetchReportsError, setFetchReportsError] = useState<string | null>(
    null
  );

  useEffect(() => {
    const fetchReports = async () => {
      try {
        setFetchingReports(true);

        const url = getApiUrl("/admin/reports", { sort: "desc", limit: 100 });

        const response = await fetchWithAuth(url, {
          headers: getTokenizedHeaders(),
        });

        setData(response);
      } catch (err: any) {
        setFetchReportsError(err.message || "Something went wrong");
      } finally {
        setFetchingReports(false);
      }
    };

    fetchReports();

    // eslint-disable-next-line
  }, []);

  return {
    reports: data?.reports,
    metaData: data?.metaData,
    fetchingReports,
    fetchReportsError,
    setFetchingReports,
    setFetchReportsError,
  };
};

export default useFetchReports;

type MetaDataType = {
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  totalPages: number;
  totalReports: number;
};

type DataType = {
  reports: FetchedReportData[];
  metaData: MetaDataType;
};
